var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('core-systembar'),_c('core-app-bar'),_c('core-drawer'),_c('core-view'),_c('core-footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }